define([
	"csi/def/ActionFactory",
	"./_CustomViewAction",
	"./SelectPlugin"
], function(ActionFactory,_CustomViewAction,SelectPlugin) {

	return ActionFactory.declare("CustomViewSelect", _CustomViewAction, {
		classController: "csi/view/customview/SelectController",
		classToolbarPlugin: SelectPlugin
	});
});